import { useEffect, useState } from 'react'
import type { ReactNode } from 'react'
import type { CatalogProduct } from '../../../types'
import type { CatalogProductFieldDefinition } from '../../../pluginFields'
import type { ShopLocale } from '../../../../i18n/shopLocale'
import { ProductFieldRuntimeView } from './runtime-view'
import { buildProductFieldRuntimeRequest, fetchProductFieldRuntime, type ProductFieldRuntimeResponse } from './runtime'

type Props = {
  field: CatalogProductFieldDefinition
  value: unknown
  productData: CatalogProduct | null
  locale?: ShopLocale
  fallback: ReactNode
  className?: string
}

export const ProductFieldRuntimeSlot = ({ field, value, productData, locale, fallback, className }: Props) => {
  const [runtimeResult, setRuntimeResult] = useState<ProductFieldRuntimeResponse | null>(null)
  const request = buildProductFieldRuntimeRequest({
    field,
    value,
    productData,
    locale,
  })

  useEffect(() => {
    if (!request) {
      setRuntimeResult(null)
      return
    }

    const controller = new AbortController()
    let active = true
    setRuntimeResult(null)

    void fetchProductFieldRuntime(request, controller.signal)
      .then((result) => {
        if (active) setRuntimeResult(result)
      })
      .catch((error) => {
        if (!active) return
        setRuntimeResult({
          ok: false,
          code: 'NETWORK_ERROR',
          message: error instanceof Error ? error.message : 'Renderer runtime request failed',
        })
      })

    return () => {
      active = false
      controller.abort()
    }
  }, [request?.requestKey])

  return <ProductFieldRuntimeView fallback={fallback} runtimeResult={runtimeResult} className={className} />
}
